export interface IPaymentMethod {
  bankType?: BankType;
  type: PaymentMethodType
  name?: string;
  logoUrl?: string;
}

export interface DocumentPayment {
  remoteDocumentId: number;
  amount: number;
}

export enum PaymentLocale {
  ET = "ET",
  EN = "EN",
  RU = "RU"
}

export enum BankType {
  SEB = 'SEB',
  SWEDBANK = 'SWEDBANK',
  LHV = 'LHV',
  LUMINOR = 'LUMINOR',
  COOP = 'COOP',
  CITADELE = 'CITADELE',
  REVOLUT = 'REVOLUT',
  N26 = 'N26',
  WISE = 'WISE',
  BIGBANK = 'BIGBANK'
}

export enum PaymentMethodType {
  BANK = 'BANK',
  CARD = 'CARD'
}